import { render, staticRenderFns } from "./MediaPlayerPurchaseList.vue?vue&type=template&id=107589c4&scoped=true"
import script from "./MediaPlayerPurchaseList.vue?vue&type=script&lang=js"
export * from "./MediaPlayerPurchaseList.vue?vue&type=script&lang=js"
import style0 from "./MediaPlayerPurchaseList.vue?vue&type=style&index=0&id=107589c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107589c4",
  null
  
)

export default component.exports